import { h, Component } from 'preact';
import { withTranslation } from 'react-i18next';
import { AppConstant } from '../../constant/AppConstant';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Log to a remote service if available
    if (window.logErrorToService) {
      window.logErrorToService({
        error: error.toString(),
        stack: error.stack,
        componentStack: errorInfo.componentStack,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      });
    }

    this.setState({
      hasError: true,
      error,
      errorInfo
    });
  }

  render(props, state) {
    const { t } = this.props;

    if (state.hasError) {
      // Show error UI
      return (
        <div style="padding: 20px; background: rgba(255,159,10,0.15); border: 1px solid var(--kt-orange); border-radius: 5px; margin: 20px;">
          <h3 style="color: var(--kt-orange); margin-top: 0;">
            <i class="fa fa-exclamation-triangle" /> {t(AppConstant.ERROR_SOMETHING_WENT_WRONG)}
          </h3>
          <details style="white-space: pre-wrap; font-family: monospace; font-size: 12px; color: var(--kt-orange);">
            <summary style="cursor: pointer; margin-bottom: 10px;">
              {t(AppConstant.ERROR_SEE_DETAILS)}
            </summary>
            <div style="background: var(--kt-surface2); padding: 10px; border-radius: 3px; margin-top: 10px;">
              <strong>{t(AppConstant.ERROR_LABEL)}</strong>
              <pre>{state.error && state.error.toString()}</pre>

              <strong>{t(AppConstant.ERROR_STACK_LABEL)}</strong>
              <pre>{state.error && state.error.stack}</pre>

              <strong>{t(AppConstant.ERROR_COMPONENT_STACK_LABEL)}</strong>
              <pre>{state.errorInfo && state.errorInfo.componentStack}</pre>
            </div>
          </details>
          <button
            class="btn btn-primary mt-3"
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null });
              window.location.reload();
            }}
          >
            <i class="fa fa-refresh" /> {t(AppConstant.ERROR_RELOAD_PAGE)}
          </button>
        </div>
      );
    }

    return props.children;
  }
}

export default withTranslation()(ErrorBoundary);
